/* global $ */

/**
 * Render a single list item DOM node
 * @param  {String} label    Text to render
 * @param  {String} category Category to group this list item in
 * @return {Node}            Native DOM node
 */
export default (label, category = null) => {
  const item = $('<li>', {
    html: label,
    'data-group': category,
    'aria-selected': 'false',
    class: 'awesomplete__item',
  })[0];

  return item;
};
